import React, { useState, useEffect } from "react";
import { API, UPLOADS } from "./../../config/api";

export default function Viewworkspace() {
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentImage, setPaymentImage] = useState("");
  /* NEW FILTER STATE */
  const [userIdFilter, setUserIdFilter] = useState("");

  useEffect(() => {
    fetchWorkspaces();
  }, []);

  const fetchWorkspaces = async () => {
    try {
      const res = await fetch(API.LIST_ACTIVE_WORKSPACES);
      const data = await res.json();
      setWorkspaces(data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleView = (workspace) => {
    setSelectedWorkspace(workspace);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setShowPaymentModal(false);
  };

  /* FILTERED DATA */
  const filteredWorkspaces = workspaces.filter((item) => {
    if (!userIdFilter.trim()) return true;

    return String(item.user_id)
      .toLowerCase()
      .includes(userIdFilter.toLowerCase());
  });

  const updateStatus = async (status) => {
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this workspace will permanently delete it.",
      );
      if (!confirmDelete) return;
    }

    if (status === "Hidden") {
      const confirmHide = window.confirm(
        "Hide this workspace from public listings?",
      );
      if (!confirmHide) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedWorkspace.id);
      formData.append("status", status);

      const url =
        status === "Rejected"
          ? API.DELETE_WORKSPACE
          : API.UPDATE_WORKSPACE_STATUS;

      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      alert(data.message);
      setShowModal(false);
      fetchWorkspaces();
    } catch (error) {
      console.error("Operation Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Active Workspaces Details</h2>

      {/* FILTER SECTION */}
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          gap: "12px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="Filter by User ID"
          value={userIdFilter}
          onChange={(e) => setUserIdFilter(e.target.value)}
          style={{
            padding: "10px 14px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            minWidth: "250px",
          }}
        />

        <button
          onClick={() => setUserIdFilter("")}
          style={{
            padding: "10px 18px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            background: "#f1f5f9",
          }}
        >
          Clear Filter
        </button>
      </div>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Owner</th>
              <th>City</th>
              <th>Rent</th>
              <th>Ads</th>
              <th>Active Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredWorkspaces.length > 0 ? (
              filteredWorkspaces.map((item, index) => (
                <tr key={item.id}>
                  <td data-label="Id">{index + 1}</td>
                  <td data-label="User Id">{item.user_id}</td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.owner_name}</div>
                    <div className="text-muted small">{item.phone}</div>
                  </td>
                  <td data-label="City">{item.city}</td>
                  <td data-label="Rent">
                    ₹ {Number(item.rent_price).toLocaleString("en-IN")}
                  </td>
                  <td>
                    <div className="fw-bold">{item.show_ads_days} Days</div>
                    <div className="text-muted small">₹{item.ads_amount}</div>
                  </td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.ads_start_date).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.ads_start_date).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.ads_end_date).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.ads_end_date).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td data-label="Status">
                    <span
                      className={`status-badge status-${item.status.toLowerCase()}`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handleView(item)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="11"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No workspace found for this User ID.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedWorkspace && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Workspace Details</h3>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{selectedWorkspace.owner_name}</p>
              </div>

              <div>
                <label>Mobile No</label>
                <p>{selectedWorkspace.phone}</p>
              </div>

              <div>
                <label>City/State</label>
                <p>
                  {selectedWorkspace.city}, {selectedWorkspace.state}
                </p>
              </div>

              <div>
                <label>Room Size</label>
                <p>{selectedWorkspace.size}</p>
              </div>

              <div>
                <label>Floor</label>
                <p>{selectedWorkspace.floor}</p>
              </div>

              <div>
                <label>Rent Price</label>
                <p>
                  ₹{" "}
                  {Number(selectedWorkspace.rent_price).toLocaleString("en-IN")}
                </p>
              </div>

              <div>
                <label>Location</label>
                <p>{selectedWorkspace.location}</p>
              </div>

              <div>
                <label>Current Status</label>
                <p>{selectedWorkspace.status}</p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{selectedWorkspace.show_ads_days || "N/A"}</p>
              </div>

              <div>
                <label>Payed Amount:</label>
                <p>₹{selectedWorkspace.ads_amount || 0}</p>
              </div>

              {selectedWorkspace.payment_screenshot ? (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>

                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`}
                      alt="payment"
                      style={{
                        maxWidth: "300px",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        padding: "5px",
                        transition: "transform 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <label>Payment Screenshot:</label>
                  <p>Not uploaded</p>
                </div>
              )}
            </div>
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}
            {/* <pre>{JSON.stringify(selectedWorkspace, null, 2)}</pre> */}
            <div className="description-box">
              <label>Description</label>
              <p>{selectedWorkspace.description}</p>
            </div>

            <div className="popup-images">
              {selectedWorkspace.image &&
                selectedWorkspace.image
                  .split(",")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                      alt="workspace"
                    />
                  ))}
            </div>

            <div className="modal-actions">
              {selectedWorkspace.status !== "Active" && (
                <button
                  className="btn btn-success"
                  onClick={() => updateStatus("Active")}
                >
                  Approve & List
                </button>
              )}

              {selectedWorkspace.status === "Active" ? (
                <button
                  className="btn btn-warning"
                  onClick={() => updateStatus("Hidden")}
                >
                  Hide Workspace
                </button>
              ) : selectedWorkspace.status === "Hidden" ? (
                <button
                  className="btn btn-info"
                  onClick={() => updateStatus("Active")}
                >
                  Unhide (Set Active)
                </button>
              ) : null}

              <button
                className="btn btn-danger"
                onClick={() => updateStatus("Rejected")}
              >
                Reject & Delete
              </button>

              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* PAYMENT IMAGE FULLSCREEN MODAL */}
      {/* {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={() => setShowPaymentModal(false)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                background: "#ff4444",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 10000,
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            >
              ×
            </button>

            <img
              src={paymentImage}
              alt="Payment Proof Large"
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
}
